import React from 'react'

export const Home = React.lazy(() => import('../pages/Home'))
export const PopularMovies = React.lazy(() => import('../pages/PopularMovies'))
export const MovieInfo = React.lazy(() => import('../pages/MovieInfo'))
export const WatchList = React.lazy(() => import('../pages/WatchList'))
